function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "connect"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.57823 3.5C8.31169 1.53 6.50031 0 4.30769 0C1.93254 0 0 1.7945 0 4C0 6.2055 1.93254 8 4.30769 8C6.50031 8 8.31169 6.47 8.57823 4.5L13.4615 4.5C13.7593 4.5 14 4.2765 14 4C14 3.7235 13.7593 3.5 13.4615 3.5L8.57823 3.5Z",
  transform: "translate(0 12)",
  id: "Path",
  fill: "#3A4AAF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.02612 3.36271L0.97204 0.235288C0.818405 0.000956729 0.493772 -0.0706445 0.247009 0.0765636C0.000772059 0.22277 -0.0739409 0.531707 0.0802203 0.766539L2.13325 3.89196C1.18723 4.62699 0.581639 5.74407 0.581639 6.99434C0.581639 9.20296 2.46998 11 4.79082 11C7.11166 11 9 9.20296 9 6.99434C9 4.78572 7.11166 2.98868 4.79082 2.98868C4.15997 2.98868 3.56384 3.12487 3.02612 3.36271Z",
  transform: "translate(15 9)",
  id: "Path",
  fill: "#9FABE8",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.529525 4.03688C0.529525 5.29689 1.13887 6.42268 2.09021 7.16345L0.0805894 10.2279C-0.0745262 10.4646 0.00117865 10.776 0.248411 10.9233C0.335762 10.9758 0.433173 11 0.528466 11C0.704758 11 0.877343 10.9162 0.97793 10.7628L2.98914 7.69632C3.53019 7.93651 4.13001 8.07376 4.76476 8.07376C7.09997 8.07376 9 6.26272 9 4.03688C9 1.81105 7.09997 0 4.76476 0C2.42956 0 0.529525 1.81105 0.529525 4.03688Z",
  transform: "translate(7 0)",
  id: "Path",
  fill: "#3A4AAF",
  fillRule: "evenodd",
  stroke: "none"
}));

var SvgConnect = function SvgConnect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConnect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/connect.52f1fa4b.svg";
export { ForwardRef as ReactComponent };